import React from "react";
import styles from "./DomPurify.scss";
import cx from "../utils/cx";
import DOMPurify  from 'dompurify';

// set target="_blank" and rel="noopener" for all links in the content
DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    if (node.hasAttribute('href')) { 
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener');
    }
});
// DOMPurify.removeHook('afterSanitizeAttributes');

export interface IDomPurifyProps {
    className?: string;
    as?: React.ElementType;
    content: string;
    variant: 'legal' | 'propertyDescription' | 'publicPage' | 'default'; 
    
    /**
     * we use a permanent hook to set target to _blank because we have no use case with other values yet; 
     * for other use cases we need to remove the hook temporarily 
    */
   linkTarget:  '_blank';  
   // linkTarget: '_self' | '_blank' | '_parent' | '_top';
}

const ALLOWED_TAGS = ['b','ul','ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'a', 'strong', 'em', 'blockquote', 'div', 'span', 'br', 'hr'];

const DomPurify: React.FC<IDomPurifyProps> = ({ className = '', as = 'div', content, variant, linkTarget }) => {
    const Tag = as as React.ElementType;

    if (linkTarget !== '_blank') {
        console.warn('DomPurify: linkTarget must be _blank or DOMPurify.removeHook("afterSanitizeAttributes"); should be integrated');
    }

    const html=DOMPurify.sanitize(content || '', {ALLOWED_TAGS});
    return <Tag className={cx(styles.domPurify, className, styles[variant])} dangerouslySetInnerHTML={{ __html: html }} />
};

export default DomPurify;
